import React, { useState, useEffect, useRef } from 'react';
import parse from 'html-react-parser';
import { useLocation } from 'react-router-dom';
import './Footer.css';

import { language } from '../WEBContent/Language';

import { /*set_language,*/ repo_logo_link, /*repo_site_documents_link, repo_img_link,*/ content_language, translate } from '../../../Utils';

import * as Hosts from '../../../Hosts';

//import { facebook } from "@fortawesome/free-solid-svg-icons";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const Footer = (props) => {

  const [, set_dados] = useState(null)
	const dados_config = useRef({})

  const [lang, set_lang] = useState(localStorage.getItem('lang'));
  const [, set_lang_id] = useState('1');

  const location = useLocation().pathname;

  const data_interface_navbar = {
    id: '',
    info: {},
    content: {
      childs: []
    }
  }

  const navbar = useRef(data_interface_navbar);

  const [isloading, setLoading] = useState(true);

  useEffect(() => {
  
    if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
      set_dados(navbar.current = props.dados_navbar)
    }

    if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
      set_dados(dados_config.current = props.dados_config)

      console.log('dados_config.current', dados_config.current)
    }

    if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
      set_lang('pt')
      set_lang_id('1')

      setLoading(false)
    }
    else {
      set_lang(localStorage.getItem('lang'))
      content_language.forEach(el => {
        if (el.code === localStorage.getItem('lang')) {
          set_lang_id(el.id)
        }
      })

      setLoading(false)
    }

  }, [props])
  
  const page_location = useLocation().pathname.split('/').pop();

  return isloading ?
    null
  :
    <>
      <table cellPadding="0" cellSpacing="0" align="center" className="es-footer" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', width: '100%', tableLayout: 'fixed !important', backgroundColor: 'transparent', backgroundRepeat: 'repeat', backgroundPosition: 'center top' }} >
        <tbody>
          <tr style={{ borderCollapse: 'collapse' }}>
            <td bgcolor="#efefef" align="center" style={{padding: '0', margin: '0', backgroundColor: '#efefef' }} >
              <table cellSpacing="0" cellPadding="0" align="center" bgcolor="#e5e4e4" className="es-footer-body" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', backgroundColor: '#e5e4e4', width: '600px' }} role="none">
                <tbody>
                  <tr style={{ borderCollapse: 'collapse' }}>
                    <td align="left" style={{ padding: '15px', margin: '0' }}>
                      <table width="100%" cellSpacing="0" cellPadding="0" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }}>
                        <tbody>
                          <tr style={{ borderCollapse: 'collapse' }}>
                            <td valign="top" align="center" style={{ padding: '0', margin: '0', width: '570px' }} >
                              <table width="100%" cellSpacing="0" cellPadding="0" role="presentation" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }}>
                                <tbody>
                                  <tr style={{ borderCollapse: 'collapse' }}>
                                    <td align="center" style={{ padding: '0', margin: '0', paddingBottom: '5px' }}>
                                      <h3 style={{ margin: '0', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", msoLineHeightRule: 'exactly', letterSpacing: '0', fontSize: '16px', fontStyle: 'normal', fontWeight: 'normal', lineHeight: '24px', color: '#333333' }}>
                                        <strong>Assec Sim!</strong>
                                      </h3>
                                    </td>
                                  </tr>
                                  <tr style={{ borderCollapse: 'collapse' }}>
                                    <td align="center" style={{ padding: '0', margin: '0', paddingTop: '10px', paddingBottom: '10px' }}>
                                      <p style={{ margin: '0', msoLineHeightRule: 'exactly', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", lineHeight: '21px', letterSpacing: '0', color: '#333333', fontDize: '14px' }} >
                                        Rua Dr. António Plácido da Costa, 16 c/v <br />
                                        6200-051 Covilhã 
                                        <br /> <br />
                                        Tlf.: (+351) 275 310 651/2 | Email: sim@assec.pt
                                      </p>
                                    </td>
                                  </tr>
                                  <tr style={{ borderCollapse: 'collapse' }}>
                                    <td align="center" style={{ padding: '0', margin: '0', paddingBottom: '25px' }}>
                                      <p style={{ margin: '0', msoLineHeightRule: 'exactly', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", lineHeight: '21px', letterSpacing: '0', color: '#333333', fontDize: '14px' }} >
                                        <strong>
                                          <a target="_blank" href="https://sim.assec.pt" style={{ msoLineHeightRule: 'exactly', textDecoration: 'underline', color: '#333333', fontSize: '14px', lineHeight: '21px', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'" }} >sim.assec.pt</a>
                                        </strong>
                                      </p>
                                    </td>
                                  </tr>
                                  <tr style={{ borderCollapse: 'collapse' }}>
                                  <td align="center" style={{ padding: '0', margin: '0', paddingBottom: '5px' }}><h3 style={{ margin: '0', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", msoLineHeightRule: 'exactly', letterSpacing: '0', fontSize: '16px', fontStyle: 'normal', fontWeight: 'normal', lineHeight: '24px', color: '#333333' }}><strong>Redes Sociais</strong></h3></td>
                                  </tr>
                                  <tr style={{ borderCollapse: 'collapse' }}>
                                  <td align="center" style={{ padding: '0', margin: '0', paddingTop: '10px', paddingBottom: '10px', fontSize: '0' }} >
                                    <table cellSpacing="0" cellPadding="0" className="es-table-not-adapt es-social" role="presentation" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }}>
                                      <tr style={{ borderCollapse: 'collapse' }}>
                                      <td valign="top" align="center" style={{ padding:'0', margin: '0', paddingRight: '20px' }}>
                                        <a href="https://viewstripo.email/" style={{ msoLineHeightRule: 'exactly', textDecoration: 'underline', color: '#333333', fontSize: '14px' }} >
                                          <img width="32" height="32" title="Facebook" src="https://ellihil.stripocdn.email/content/assets/img/social-icons/logo-black/facebook-logo-black.png" alt="Fb" style={{ display: 'block', fontSize: '14px', border: '0', outline: 'none', textDecoration: 'none' }} />
                                        </a>
                                        </td>
                                      <td valign="top" align="center" style={{ padding:'0', margin: '0', paddingRight: '20px' }}>
                                        <a href="https://viewstripo.email/" style={{ msoLineHeightRule: 'exactly', textDecoration: 'underline', color: '#333333', fontSize: '14px' }} >
                                          <img title="Youtube" src="https://ellihil.stripocdn.email/content/assets/img/social-icons/logo-black/youtube-logo-black.png" alt="Yt" width="32" height="32" style={{ display: 'block', fontSize: '14px', border: '0', outline: 'none', textDecoration: 'none' }} />
                                        </a>
                                      </td>
                                      <td align="center" valign="top" style={{ padding:'0', margin: '0', paddingRight: '20px' }}>
                                        <a href="https://viewstripo.email/" style={{ msoLineHeightRule: 'exactly', textDecoration: 'underline', color: '#333333', fontSize: '14px' }} >
                                          <img height="32" title="Pinterest" src="https://ellihil.stripocdn.email/content/assets/img/social-icons/logo-black/pinterest-logo-black.png" alt="P" width="32" style={{ display: 'block', fontSize: '14px', border: '0', outline: 'none', textDecoration: 'none' }} />
                                        </a>
                                      </td>
                                      <td valign="top" align="center" style={{ padding:'0', margin: '0', paddingRight: '20px' }}>
                                        <a href="https://viewstripo.email/" target="_blank" style={{ msoLineHeightRule: 'exactly', textDecoration: 'underline', color: '#333333', fontSize: '14px' }} >
                                          <img alt="Ig" width="32" height="32" title="Instagram" src="https://ellihil.stripocdn.email/content/assets/img/social-icons/logo-black/instagram-logo-black.png" style={{ display: 'block', fontSize: '14px', border: '0', outline: 'none', textDecoration: 'none' }} />
                                        </a>
                                      </td>
                                      <td valign="top" align="center" style={{ padding: '0', margin: '0' }} >
                                        <a href="https://viewstripo.email/" target="_blank" style={{ msoLineHeightRule: 'exactly', textDecoration: 'underline', color: '#333333', fontSize: '14px' }} >
                                          <img title="Х" src="https://ellihil.stripocdn.email/content/assets/img/social-icons/logo-black/x-logo-black.png" alt="Х" width="32" height="32" style={{ display: 'block', fontSize: '14px', border: '0', outline: 'none', textDecoration: 'none' }} />
                                        </a>
                                      </td>
                                      </tr>
                                    </table></td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table cellPadding="0" cellSpacing="0" align="center" className="es-footer" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', width: '100%', tableLayout: 'fixed !important', backgroundColor: 'transparent', backgroundRepeat: 'repeat', backgroundPosition: 'center top' }} >
        <tbody>
          <tr style={{ borderCollapse: 'collapse' }}>
            <td align="center" bgcolor="#efefef" style={{padding: '0', margin: '0', backgroundColor: '#efefef' }} >
              <table align="center" bgcolor="#333333" cellSpacing="0" cellPadding="0" className="es-footer-body" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', backgroundColor: '#333333', width: '600px' }} role="none">
                <tbody>
                  <tr style={{ borderCollapse: 'collapse' }}>
                    <td align="left" style={{ padding: '0', margin: '0', paddingRight: '5px', paddingBottom: '5px', paddingLeft: '5px' }} >
                      <table width="100%" cellSpacing="0" cellPadding="0" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }}>
                        <tbody>
                          <tr style={{ borderCollapse: 'collapse' }}>
                            <td valign="top" align="center" style={{ padding: '0', margin: '0', width: '590px' }} >
                              <table width="100%" cellSpacing="0" cellPadding="0" role="presentation" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }}>
                                <tbody>
                                  <tr style={{ borderCollapse: 'collapse' }}>
                                    <td align="center" className="es-text-4627" style={{ padding: '0', margin: '0', paddingTop: '10px', paddingBottom: '10px' }}>
                                      <h6 className="es-text-mobile-size-12" style={{ margin: '0', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", msoLineHeightRule: 'exactly', letterSpacing: '0', fontSize: '12px', fontStyle: 'normal', fontWeight: 'normal', lineHeight: '18px', color: '#ffffff' }} >
                                        Recebeu este email porque subscreveu a newslettter da Assec Sim! <br />
                                        Para cancelar a subscrição, 
                                        <a target="_blank" href="https://link.aaa" style={{ msoLineH0eightRule: 'exactly', textDecoration: 'underline', color: '#ffffff', fontSize: '12px', lineHeight: '18px', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'" }} >clique aqui.</a>
                                      </h6>
                                    </td>
                                  </tr>
                                  <tr style={{ borderCollapse: 'collapse' }}>
                                    <td align="center" className="es-text-9389" style={{ padding: '0', margin: '0', paddingBottom: '10px' }}>
                                      <h6 className="es-text-mobile-size-12" style={{ margin: '0', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", msoLineHeightRule: 'exactly', letterSpacing: '0', fontSize: '12px', fontStyle: 'normal', fontWeight: 'normal', lineHeight: '18px !important', color: '#ffffff' }} >© 2024 Assec Sim! | Todos os direitos reservados. | Desenvolvido por Assec Sim!</h6>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </>


};
export default Footer;